import { render, staticRenderFns } from "./dialog-browse-customer.vue?vue&type=template&id=039fa512&"
import script from "./dialog-browse-customer.vue?vue&type=script&lang=js&"
export * from "./dialog-browse-customer.vue?vue&type=script&lang=js&"
import style0 from "./dialog-browse-customer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports